import { z } from 'zod'

export const DAYS_OF_THE_WEEK = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'] as const
export const isDayOfTheWeek = (day: string): day is DayOfTheWeek => {
  return DAYS_OF_THE_WEEK.includes(day as DayOfTheWeek)
}
export type DayOfTheWeek = (typeof DAYS_OF_THE_WEEK)[number]

export const DayOfTheWeekSchema = z.enum(DAYS_OF_THE_WEEK)

export const DayOfTheWeekAbbreviation = {
  Sunday: 'Sun',
  Monday: 'Mon',
  Tuesday: 'Tue',
  Wednesday: 'Wed',
  Thursday: 'Thu',
  Friday: 'Fri',
  Saturday: 'Sat',
} as const

export const WEEK_DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'] as const
